import { IChartConfiguration } from "@common-modules/shared/charts/model/chart/ichart-configuration";
import { Observable, Subject } from "rxjs";
import { BaseChartService } from "../base-chart/base-chart.service";
import { GenericCartesianChartSettings } from "../models/generic-chart-settings/generic-cartesian-chart-settings";
import { GenericChartService } from "../services/generic-chart.service";

export abstract class BaseCustomizableChartDataService extends BaseChartService<GenericCartesianChartSettings>{
    genericChartService: GenericChartService;

    _genericChartServiceLoaded$ = new Subject<boolean>();
    genericChartServiceLoaded$ = this._genericChartServiceLoaded$.asObservable();

    setGenericChartService(genericChartService: GenericChartService) {
        this.genericChartService = genericChartService;
        this._genericChartServiceLoaded$.next(true);
    }

    abstract getData(chartConfiguration: IChartConfiguration): Observable<any>;
    abstract mapDataToGenericSettings(data: any): Observable<GenericCartesianChartSettings>;
}